import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initAnalytics } from "./services/analytics";
import "./styles.css";

initAnalytics();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
